export default __webpack_public_path__ + "static/media/5.9fde0095.jpg";